export const domain = 'Categories';

// action types
export const FETCH_ERROR = `${domain}/FETCH_ERROR`;
export const IS_FETCHING = `${domain}/IS_FETCHING`;
export const LAST_FETCH_TIME = `${domain}/LAST_FETCH_TIME`;
export const RECEIVE_TOP_CATEGORIES = `${domain}/RECEIVE_TOP_CATEGORIES`;
export const RECEIVE_ALL_CATEGORIES = `${domain}/RECEIVE_ALL_CATEGORIES`;
export const RECEIVE_TOP_FEATURED_IMAGES = `${domain}/RECEIVE_TOP_FEATURED_IMAGES`;
